import { JSX } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { InstallInstructions } from '../components/install-instructions';
import { useLayout } from '../hooks/layout.hook';
import { useNavigation } from '../hooks/navigation.hook';
import { useAppStore } from '../stores/app.store';

export default function HomeScreen(): JSX.Element {
  const { navigate } = useNavigation();
  const { t } = useTranslation();

  const isDark = useAppStore((s) => s.isDark);

  useLayout(() => ({ hideFooter: true }), []);

  return (
    <>
      <div className="flex-grow-1 flex flex-col gap-8 justify-center items-center">
        <img src={isDark ? '/logo-dark.jpg' : '/logo.jpg'} alt="Virtus Logo" className="h-40" />

        <div className="text-center">
          <Trans i18nKey="virtus">
            Welcome to
            <AppTitle />
            your app for spiritual growth and good habits!
          </Trans>
        </div>

        <div className="flex flex-col gap-3">
          <div className="text-base-content/70 hyphens-auto">
            {t(
              'With Virtus, you turn big ideals into concrete goals: daily resolutions, simple progress tracking, visible progress. This is how you build good habits, deepen your life with Christ, and walk together with others on your path to holiness.',
            )}
          </div>
        </div>

        <div className="w-full flex flex-col gap-3">
          <button className="btn btn-neutral btn-lg w-full" onClick={() => navigate('/description')}>
            {t('More info')}
          </button>
          <button className="btn btn-primary btn-lg w-full" onClick={() => navigate('/auth')}>
            {t('Get started')}
          </button>

          <div className="text-center">
            <div className="text-base-content/70">{t('Problems with installation or login?')}</div>
            <a className="link link-accent" href="mailto:sup.virtus.app@gmail.com">
              {t('Contact Support')}
            </a>
          </div>
        </div>

        <InstallInstructions />
      </div>
    </>
  );
}

function AppTitle(): JSX.Element {
  return (
    <h1 className="text-center text-5xl font-bold m-2">
      Virtus<span className="align-super text-sm font-normal">v{import.meta.env.APP_VERSION}</span>
    </h1>
  );
}
